// This function help to get Mime type from file extension
// It's not perfect, as the file extension could be wrong
// All types are not present in the switch
// All types supported by filePreview component are available
export function getMimeTypeFromExtension(fileName: string): string {
    let mimeType = '';
    if (fileName) {
        const extension = fileName.substr(fileName.lastIndexOf('.') + 1);
        switch (extension) {
            case 'pdf':
                mimeType = 'application/pdf';
                break;
            case 'png':
                mimeType = 'image/png';
                break;
            case 'jpg':
            case 'jpeg':
                mimeType = 'image/jpg';
                break;
            case 'bmp':
                mimeType = 'image/bmp';
                break;
            case 'gif':
                mimeType = 'image/gif';
                break;
            case 'txt':
            case 'csv':
            case 'xml':
            case 'json':
                mimeType = 'plain/text';
                break;
        }
    }
    return mimeType;
}